// Copyright (c) 2019-2023 Cigent Technology Inc. All Rights Reserved.


export function pushFileToDesktop(blob: Blob, filename: string) {
    if ((window.navigator as any).msSaveOrOpenBlob) {
        (window.navigator as any).msSaveBlob(blob, filename);
    } else {
        const elem = window.document.createElement('a');
        elem.href = window.URL.createObjectURL(blob);
        elem.download = filename;
        document.body.appendChild(elem);
        elem.click();
        // elem.dispatchEvent(new Event('click'));
        document.body.removeChild(elem);
    }
}

export function arrayBufferToBase64( buffer ): string {
    let binary = '';
    const bytes = new Uint8Array( buffer );
    const len = bytes.byteLength;
    for (let i = 0; i < len; i++) {
        binary += String.fromCharCode( bytes[ i ] );
    }
    return window.btoa( binary );
}

export function  base64ToArrayBuffer(base64String: string): ArrayBuffer {
    const binary_string = window.atob(base64String);
    const len = binary_string.length;
    const bytes = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
        bytes[i] = binary_string.charCodeAt(i);
    }
    return bytes.buffer;
}

export function importSecretKeyGCM(rawKey: ArrayBuffer): Promise<CryptoKey> {
    // This will only work using https OR localhost.  If running http against an IP address it will fail.
    // Documentation says: This feature is available only in secure contexts.
    return window.crypto.subtle.importKey(
      'raw',
      rawKey,
      'AES-GCM',
      true,
      ['encrypt', 'decrypt']
    );
  }

export function getMessageEncoding(message: string): Uint8Array<ArrayBuffer> {
    const enc = new TextEncoder();
    return enc.encode(message);
}

export async function encodeGSM(message: string, iv: ArrayBuffer, key: CryptoKey) {
    const encoded = getMessageEncoding(message);
    const ciphertext = await window.crypto.subtle.encrypt(
      {
        name: 'AES-GCM',
        iv: iv
      },
      key,
      encoded
    );

    return ciphertext;
}

export async function decodeGSM(encryptedContent: ArrayBuffer, iv: ArrayBuffer, crypto_key: CryptoKey): Promise<ArrayBuffer> {
    const ALGO = {name: 'AES-GCM', iv: iv};
    const decryptedContent = await window.crypto.subtle.decrypt(ALGO, crypto_key, encryptedContent);

    return decryptedContent;
}
